import React, { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { host } from './../../../../configuraciones'
import { useDispatch, useSelector } from "react-redux";
import {
  servirConstancias
} from "../../../../redux/DucksUsuarioAgricola/ConstanciaDucks";
import { faDownload, faEnvelope } from "@fortawesome/free-solid-svg-icons";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableFooter from "@mui/material/TableFooter";
import TextField from '@mui/material/TextField';
import { obtenerDatosPredioByIdCliente } from "../../../../redux/DucksUsuarioAgricola/DatosPredioDucks";
import PDFMerger from 'pdf-merger-js/browser';

const Constancia = (props) => {

  const dispatch = useDispatch();
  const dataValues = props.dataValues;

  const dataTableHead = props.dataTableHead;

  //const idPredio = (number, len) => "0".repeat(len - number.toString().length) + number.toString();

  const idPredio = (input, len) => {
    const number = parseInt(input, 10);
    const paddedNumber = number.toString().padStart(len, "0");
    return paddedNumber;
  };

  // let dataPredio = useSelector((store) => store.DatosPredioApi.data.data);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [search, setSearch] = React.useState("");
  const [dataTable, setDataTable] = React.useState(dataValues);

  const [asociado, setAsociado] = React.useState({
    numerosocio: null,
    idcliente: null,
    personafisica: null,
    personamoral: null,
    nombrerazonsocial: null,
    fechasolicitud: null,
    rfc: null,
    telefono: null,
    correoelectronico: null,
    nombrerepresentantelegal: null,
    telefonorepresentante: null,
    correoelectronicorepresentante: null,
    empresacertificadora: null,
    idtipocliente: null,
    idlogin: null,
    idcartera: null,
  });

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataTable.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };




  const filterValues = (valueSearch) => {
    const dataFilter = dataTable.filter((item) => {
      console.log("item ", item)
      if (
        item.datospredio.cliente.nombrerazonsocial
          .toString()
          .toLowerCase()
          .includes(valueSearch.toString().toLowerCase()) ||
        item.datospredio.cliente.idcliente
          .toString()
          .toLowerCase()
          .includes(valueSearch.toString().toLowerCase()) ||
        item.datospredio.cliente.numerosocio
          .toString()
          .toLowerCase()
          .includes(valueSearch.toString().toLowerCase()) ||
        idPredio(item.iddatospredio, 5)
          .toString()
          .toLowerCase()
          .includes(valueSearch.toString().toLowerCase())

      ) {
        return item;
      }
    });
    setDataTable(dataFilter);
  };

  React.useEffect(() => {
    if (!search.trim() || !search) {
      setDataTable(dataValues)
      return
    }

    filterValues(search)

  }, [search])



  React.useEffect(() => {

    if (asociado.idcliente !== null) {
      dispatch(obtenerDatosPredioByIdCliente(asociado.idcliente));
    }
  }, [asociado])



  const servirArchivo = async (fila) => {
    let ruta = fila.constanciaruta
    const fileFetch = await fetch(host + `Constancia/servirConstancia/ruta=${encodeURIComponent(ruta)}`)
    const merger = new PDFMerger();


    if (fileFetch.status != 404) {
      const blob = await fileFetch.blob();
      //merger.save(`Registropredioguias_${iddatospredio}`)
      const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
      await merger.add(url)
      merger.save(`RegistroPredio${fila.iddatospredio}`)
      //window.open(url);
    }
  }



  return (
    <Fragment>
      <div className="row">
        <div className="col-12">
          <br />
          <TextField
            id="a"
            fullWidth
            value={search}
            label="Buscar"
            onChange={e => { setSearch(e.target.value) }}
          />
          <br />
        </div>
      </div>
      <br />

      <div className="row">
        <div className="col-12">
          <Paper sx={{ width: "100%" }}>
            <TableContainer sx={{ maxHeight: 600 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    {dataTableHead.map((item, i) => (
                      <TableCell key={i}>{item}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {(rowsPerPage > 0
                    ? dataTable.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    : dataTable
                  ).map((row, i) => (
                    <TableRow key={i}>
                      <TableCell component="th" scope="row">
                        {/*i+1*/idPredio(row.iddatospredio, 5)}
                      </TableCell>
                      <TableCell>{row?.datospredio?.cliente?.numerosocio}</TableCell>
                      <TableCell>{row?.datospredio?.cliente?.nombrerazonsocial?.toUpperCase()}</TableCell>
                      <TableCell>
                        <button className="badge btn-warning text-dark btn-block" onClick={() => { servirArchivo(row) }} target="_blank">
                          <FontAwesomeIcon icon={faDownload} />
                          <br />
                          Descargar
                        </button>
                      </TableCell>
                      {/*<TableCell>
                        <button className="badge btn-primary text-white btn-block" onClick={() => { alert('Enviado') }}>
                          <FontAwesomeIcon icon={faEnvelope} />
                          <br />
                          Enviar E-mail
                        </button>
                      </TableCell>*/}
                    </TableRow>
                  ))}

                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[
                        5,
                        10,
                        25,
                        { label: "Todos", value: -1 },
                      ]}
                      labelDisplayedRows={({ from, to, count }) =>
                        ` ${from}-${to} de ${count}`
                      }
                      labelRowsPerPage={<span>Registros por página:</span>}
                      count={dataTable.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      showLastButton={true}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Paper>
        </div>
      </div>

    </Fragment>
  );
};

export default Constancia;
